import React, { useEffect, useState } from 'react';
import { Route, Routes, useLocation } from "react-router-dom";
import './App.css';
import AllLeads from './Leads';
import AllLeadsCopy from './LeadsCopy';
import Renewals from './renwals/Renewals';
import SystemManagement from './SystemManagement';
import { Simulator } from './Sim'
import { Subscribers } from './subscribers/Subscribers'
import Emails from './emails/Emails';
import Whatsapp from './whatsup/Whatsup';
import Login from './login/login'
import './assets/css/site.css'
import './assets/css/app.css'
import Clients from './clients/Clients';
import IdleTimer from './_IdleTimer';
import { LoginModel } from './models/LoginModel';
import Tasks from './tasks/Tasks';
import PaymentSuccessPage from './Payments/PaymentSuccessPage';
import { useDispatch } from 'react-redux'
import { logIn, logOut } from './app-context/user'
import CallStatus from './calls/_CallStatus';
import Signing from './signigs/Signing';
import Sues from './sues/Sues';
import ProtectedRoute from './login/ProtectedRoute';
import { useVersionChecker } from "./hooks/useVersionChecker";

const App = () => {

  useVersionChecker(60000);

  const [logoutTimeout, setLogoutTimeout] = useState<number | null>(null); // 1 hour(default)

  const loginModel: LoginModel = new LoginModel();
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  // const userLogged = useSelector((state: any) => state.user.value)




  useEffect(() => {
    fetchData();
    // console.log('init App', loginModel.isAuthTokenSaved());

    const savedAuthToken = localStorage.getItem('AuthToken');
    if (savedAuthToken) {
      dispatch(logIn());
    }
  }, []);

  useEffect(() => {
    if (location.pathname !== '/Login') {
      localStorage.setItem('lastPathName', location.pathname);
    }
  }, [location]);



  const fetchData = async () => {
    try {

      const response = await fetch('/config.json');
      const jsonData = await response.json();
      localStorage.setItem('apiUrl', jsonData.apiUrl)
      localStorage.setItem('callDownloadPath', jsonData.callDownloadPath);
      localStorage.setItem('appConfig', JSON.stringify(jsonData));

      if (jsonData.logoutTimeout) {

        setLogoutTimeout(jsonData.logoutTimeout);
      }
      // setData(jsonData);
    } catch (error) {
      console.error('Error fetching data: ', error);
    }
  };


  const handleIdle = async () => {
    await loginModel.logOut(true);
    dispatch(logOut())
  }


  return (
    <>
      {/* <div>
      <button
          onClick={() => dispatch(startCall())}>Test +</button>
      <button
          onClick={() => dispatch(endCall())}>Test -</button>
    </div> */}
      {logoutTimeout && <IdleTimer timeout={logoutTimeout} onIdle={handleIdle} />}
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/Login" element={<Login />} />
        <Route element={<ProtectedRoute />}>
          {/* <Route path="/Leads" element={<AllLeads />} /> */}
          <Route path="/Leads" element={<AllLeadsCopy />} />

          <Route path="/Simulator" element={<Simulator leadId='' offerId='' />} />
          <Route path="/Subscribers" element={<Subscribers />} />
          <Route path="/Emails" element={<Emails />} />
          <Route path="/Clients" element={<Clients />} />
          <Route path="/Tasks" element={<Tasks />} />
          <Route path="/Signing" element={<Signing />} />
          <Route path="/Sues" element={<Sues showTabs={true} />} />
          <Route path="/Whatsapp" element={<Whatsapp />} />
          <Route path="/PaymentSuccessPage" element={<PaymentSuccessPage />} />
          <Route path="/Renewals" element={<Renewals />} />
          <Route path="/SystemManagement" element={<SystemManagement />} />
        </Route>
        <Route path="*" element={<h1>Not Found</h1>} />
      </Routes>
      <CallStatus />
    </>
  );
}
export default App;